import React, {useEffect} from "react";
import EditPartnerGeneralInformationSection from "./edit-general-information";
import {useConfigureNotebook} from "../../../../hooks/use-notebook-config";
import useBehavioralAnalyticsTool from "../../../../hooks/use-behavioural-analytics-tool";
import {usePartnerInformationController} from "../../../../hooks/use-partner-information";
import Grid2 from "@mui/material/Unstable_Grid2";
import EditPartnerAddressInformationSection from "./edit-address-information";

const PartnerProfileView = () => {
    const {getPartnerInformation} = usePartnerInformationController();

    const {configureNotebookTags} = useConfigureNotebook('partner-profile-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool
     */
    useEffect(() => {
        configureNotebookTags((tags) => tags.partnerProfile);
        configureBehavioralTool((tags) => tags.partnerProfile);
    }, [configureNotebookTags, configureBehavioralTool]);


    /**
     * With first render of the component:
     * - fetches the partner information by calling the related api
     */
    useEffect(() => {
        void getPartnerInformation({disregardCache: true});
    }, [getPartnerInformation])

    return (
        <>
            <Grid2 container spacing={4}>
                <Grid2 xs={12}>
                    <p className={'view-title'}>
                        Manage Organization's Profile
                    </p>
                </Grid2>
                <Grid2 xs={12} md={6}>
                    <EditPartnerGeneralInformationSection/>
                </Grid2>
                <Grid2 xs={12} md={6}>
                    <EditPartnerAddressInformationSection/>
                </Grid2>
            </Grid2>
        </>
    );
}

export default PartnerProfileView;
